import { useEffect, useNavigate } from "react";
import React  from "react";

const Panel=()=>{

    useEffect(() => {
        window.location.href = "https://panel.bikuyum.com/panel";
      }, []);
    
      return null; 
    };
export default Panel;